import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  apiPrefix: string;
  headers = new HttpHeaders();

  constructor(private http: HttpClient) {
    this.apiPrefix = environment.baseUrl + 'api/v1/dashboard/';
    this.headers = this.headers.set('x-access-token', localStorage.getItem("adventouresAdminAuthToken"));
  }

  getDashboardSummary(params) {
    return this.http.post(this.apiPrefix + 'summary', params, {headers: this.headers });
  }
}
